import React from "react";
import Img from "./Img";

const RowPhoto = ({ src }) => {
  return (
    <div className="row-photo">
      <Img src={src} border={true} />
    </div>
  );
};

export default RowPhoto;
